import { Injectable, inject } from '@angular/core';
import { PostsRequestQuery } from '@app/src/app/modules/post/graphql/default/posts.request.query';
import { PostRequestQuery } from '@app/src/app/modules/post/graphql/default/post.request.query';
import { PostByRequestQuery } from '@app/src/app/modules/post/graphql/default/post.by.request.query';
import { PostRequestMutation } from '@app/src/app/modules/post/graphql/default/post.request.mutation';
import { PostsPublicRequestQuery } from '@app/src/app/modules/post/graphql/default/posts.public.request.query';
import { PostExistsRequestQuery } from '@app/src/app/modules/post/graphql/default/post.exists.request.query';
import {
  buildPayload,
  DashboardGlobalConfigType,
  ItemNotFound,
} from '@ckmk/angular';
import { ActivatedRouteSnapshot } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class PostService {
  public readonly list = inject(PostsRequestQuery);

  public readonly single = inject(PostRequestQuery);

  public readonly manage = inject(PostRequestMutation);

  public readonly exists = inject(PostExistsRequestQuery);

  public readonly post = inject(PostByRequestQuery);

  public readonly posts = inject(PostsPublicRequestQuery);

  public constructor() {}

  public async isExists(
    route: ActivatedRouteSnapshot,
    config?: DashboardGlobalConfigType,
  ): Promise<boolean> {
    return this.exists
      .fetchQuery(
        buildPayload()
          .into('payload', (pl) =>
            pl.filters((filter) => {
              if (config) {
                filter.equalTo('id', route.params['post']);
              } else {
                filter
                  .equalTo('active', true)
                  .equalTo('slug', route.params['post'])
                  .concat('category', (subFilter) =>
                    subFilter
                      .equalTo('active', true)
                      .equalTo('slug', route.params['category']),
                  );
              }
            }),
          )
          .build(),
      )
      .then((value) => !!value);
  }

  public fetchBySlug(slug?: string | null, categorySlug?: string | null) {
    if (slug && categorySlug) {
      return this.post
        .fetchQuery(this.buildSlugPayload(slug, categorySlug))
        .then((res) => {
          if (res instanceof ItemNotFound) {
            return null;
          }

          return res;
        });
    }

    return null;
  }

  public watchBySlug(slug?: string, categorySlug?: string): void {
    if (slug && categorySlug) {
      this.post.watchQuery(this.buildSlugPayload(slug, categorySlug));
    }
  }

  public watchOtherPost(slug?: string, categorySlug?: string): void {
    if (slug && categorySlug) {
      this.posts.watchQuery(
        this.posts
          .payload()
          .into('payload', (pl) =>
            pl
              .setMultiple({
                includeCategory: true,
                includePicture: true,
              })
              .filters((filter) =>
                filter
                  .equalTo('active', true)
                  .notEqualTo('slug', slug)
                  .concat('category', (subFilter) =>
                    subFilter
                      .equalTo('active', true)
                      .equalTo('slug', categorySlug),
                  ),
              ),
          )
          .build() as any,
      );
    }
  }

  protected buildSlugPayload(slug?: string, categorySlug?: string): any {
    if (slug && categorySlug) {
      return buildPayload()
        .into('payload', (builder) =>
          builder
            .setMultiple({
              includeCategory: true,
              includePicture: true,
              includeCover: true,
              includePictures: true,
            })
            .filters((filter) =>
              filter
                .equalTo('active', true)
                .equalTo('slug', slug)
                .concat('category', (subFilter) =>
                  subFilter
                    .equalTo('active', true)
                    .equalTo('slug', categorySlug),
                ),
            ),
        )
        .build();
    }
  }
}
